import React, { FC } from 'react'

import { Text } from 'mf-ui-components'
import {
  ComponentWrapper,
  ContributionAndOutcome,
  ContributionItem,
  Profit,
  ProfitText,
} from './ExpectedPerformanceValues.styles'

type Props = {
  contributionText: string
  contributionValue: string
  projectionText: string
  projectionValue: string
  profitText: string
  profitValue: string
}

export const ExpectedPerformanceValues: FC<Props> = ({
  contributionText,
  contributionValue,
  projectionText,
  projectionValue,
  profitText,
  profitValue,
}) => (
  <ComponentWrapper>
    <ContributionAndOutcome>
      {[
        { label: contributionText, value: contributionValue },
        { label: projectionText, value: projectionValue },
      ].map(({ label, value }, index) => (
        <ContributionItem key={index}>
          <Text el="span" styleName="title3">
            {value}
          </Text>
          <Text
            el="span"
            styleName="bodySmall"
            variant={index === 0 ? 'secondary' : undefined}
          >
            {label}
          </Text>
        </ContributionItem>
      ))}
    </ContributionAndOutcome>

    <Profit>
      <ProfitText el="span" styleName="title7" variant="secondary">
        {profitText}
      </ProfitText>
      <Text el="span" styleName="title3">
        {profitValue}
      </Text>
    </Profit>
  </ComponentWrapper>
)
